import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { API_STATUS_MESSAGES } from 'src/app/core/properties/application.properties';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  defaultConfig = {
    life: 4000, // In Milliseconds toast stay
    summary: '',
    detail: '',
  };

  constructor(private messageService: MessageService) {}

  showToast(config): void {
    const finalConfiguration = Object.assign(this.defaultConfig, config);
    this.getMsgConfiguration(finalConfiguration, finalConfiguration.severity as string);
    this.messageService.add(finalConfiguration);
  }

  getMsgConfiguration(config, toastType: string): void {
    this.defaultConfig.summary = config.summary ? config.summary : toastType.toUpperCase();
    this.defaultConfig.detail = config.detail
      ? config.detail
      : API_STATUS_MESSAGES[toastType].DEFAULT_MESSAGE;
  }
}
